<ng-container *ngIf="isShowContent; else showHyphen"
  ><div class="c-plan-table01__col-inner" #juniorPilot>
    <!-- (18-9) ジュニアパイロット申込状況 -->
    <div
      class="c-plan-table01__col-item c-plan-table01__col-item--fs16"
      *ngIf="getJuniorPilotServiceStatus; let juniorPilotServiceStatus"
      [innerHTML]="juniorPilotServiceStatus | staticMsg"
    ></div>
  </div>
</ng-container>
<ng-template #showHyphen>
  <div class="c-plan-table01__col-inner">
    <div class="c-plan-table01__col-item c-plan-table01__col-item--fs16" [innerHTML]="'label.hyphen' | staticMsg"></div>
  </div>
</ng-template>
